import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { ReactHookFormIntlNumberInput } from 'common/components/form';

import { handleOnBlurField } from '../../helpers';

const TaxOnInterest = ({ control, disabled, setValue }) => {
    const { t } = useTranslation();
    const name = 'parameters.tax';
    return (
        <ReactHookFormIntlNumberInput
            append="%"
            control={control}
            disabled={disabled}
            fullWidth
            label={t('Tax on interest')}
            name={name}
            onBlur={({ value }) => handleOnBlurField({ name, setValue, value })}
        />
    );
};

TaxOnInterest.propTypes = {
    control: PropTypes.object,
    disabled: PropTypes.bool,
    setValue: PropTypes.func,
};

export default TaxOnInterest;
